import { css } from '@emotion/react';
import styled from '@emotion/styled';


export const MatrixContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
`;

export const MatrixRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    /* margin: 10px 0; */
`;

type MatrixCellProps = {
    color?: string;
    isSelect?: boolean;
}
export const MatrixCell = styled.div<MatrixCellProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    /* margin: 0 10px; */
    box-sizing: border-box;
    background-color: ${(props) => props.color ?? '#eee'};
    text-align: center;
    cursor: pointer;
    font-size: 12px;
    ${(props) => props.isSelect && css`background: white`}
    * {
        font-size: 12px;
    }
`;
